// extracted by mini-css-extract-plugin
export var dividerContainer = "_64-0";
export var line = "_64-1";